import { BasicRequest } from "./basicRequest";

export class DeleteMoovStepCustomerParametersRequest extends BasicRequest{
    
    public moovStepCustomerParametersId!:number;

    constructor(){
        super();
    }
}